import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_j2hghp5gvd: FaireBrandEntity = {
  token: "b_j2hghp5gvd",
  type: "brand",
  name: "Mirazshoes WholeSale",
  avatarUrl:
    "https://cdn.faire.com/fastly/3d561f8b1cdeac4e452c0de685a595c5a5484d18863394f0523413acfdd29e5f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9f07a8e84de6f42f0947f7f602d7da49d9fe29e5b5547988bdc58d87503d729c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3d561f8b1cdeac4e452c0de685a595c5a5484d18863394f0523413acfdd29e5f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9f07a8e84de6f42f0947f7f602d7da49d9fe29e5b5547988bdc58d87503d729c.jpeg",
  location: "Tampa, FL, USA",
  minimumOrderDollars: 130,
  rating: 3.8,
  reviewCount: 11,
  isInsider: true,
  description:
    "Since our founding, MirazShoes has embodied the timeless elegance of Italian craftsmanship, merging it with contemporary fashion sensibilities to redefine modern footwear. Rooted in Italy’s rich heritage of shoemaking—where attention to detail, premium materials, and artisanal skill are sacred—we craft shoes that are more than just accessories: they are expressions of style, confidence, and individuality.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:04.918Z",
    importedBy: "entity-db-cli",
  },
};
